<template>
    <div class="seller-info" v-if="seller?.username" :class="elClass + '-header'">
        <div class="img-container" :class="isOnlineGame ? 'online-game' : 'game'" @click="mobileShowTooltip">
            <img :src="seller.avatar && seller.avatar.src" alt="Seller Image" :class="'seller-' + elClass + '-image'" />
            <div class="online-status">
                <div :class="{ 'ico-user-status': true, 'online': seller.is_online }"></div>
            </div>
        </div>
        <div class="seller-info__right" :class="elClass">
            <div class="seller-info__right-name" :class="elClass">
                <a v-if="seller.public_profile_url" :href="seller.public_profile_url" class="seller-name" :class="elClass"  target="_blank" rel="nofollow noopener">
                    {{ seller.username }}
                </a>
                <h3 v-else class="seller-name" :class="elClass">
                    {{ seller.username }}
                </h3>
                <TrustedIconAlt :isVerified="seller.is_verified" :isTrusted="seller.is_trusted" />
            </div>
            <div v-if="!tablet && !mobile" class="seller-info__right-description" :class="elClass">
                <p class="seller-info__right-rank" :class="elClass + '-rank'" v-if="seller.seller_membership">
                    <span class="rank-title" v-if="elClass === 'head'">{{ $t("Rank") }}:</span>
                    <i :class="'ico achievement-cup achievement-cup-' + (seller.seller_membership && seller.seller_membership.pos)"></i>
                    <span class="achi-name" :class="elClass">{{ seller.seller_membership && seller.seller_membership.name }}</span>
                </p>
                <p class="seller-info__right-rate star">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.8504 5.6233L8.7876 4.76581L6.7168 1.16699V11.1392L10.5075 12.8337L10.0675 8.70478L12.8504 5.6233Z" fill="#FFC700"/>
                        <path d="M4.64581 4.76581L0.583008 5.6233L3.36594 8.70478L2.92593 12.8337L6.71661 11.1392V1.16699L4.64581 4.76581Z" fill="#FFC700"/>
                    </svg>
                    <span>{{ getStarCount(seller.success_rate) }}</span>
                </p>
                <p class="seller-info__right-sale" v-if="!simplified">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.65554 12.6587C6.41723 12.6587 7.0347 12.0412 7.0347 11.2796C7.0347 10.5179 6.41723 9.90039 5.65554 9.90039C4.89384 9.90039 4.27637 10.5179 4.27637 11.2796C4.27637 12.0412 4.89384 12.6587 5.65554 12.6587Z" fill="#9D9D9D"/>
                        <path d="M9.68092 9.90039C8.91924 9.90039 8.30176 10.5179 8.30176 11.2795C8.30176 12.0412 8.91924 12.6587 9.68092 12.6587C10.4426 12.6587 11.0601 12.0412 11.0601 11.2795C11.0601 10.5179 10.4426 9.90039 9.68092 9.90039Z" fill="#9D9D9D"/>
                        <path d="M12.0314 8.4932H4.84007L4.69934 7.67696H10.6101C10.7839 7.67748 10.9404 7.57133 11.0041 7.40957L12.4114 3.86314C12.4969 3.64622 12.3904 3.40104 12.1734 3.31556C12.1237 3.29596 12.0708 3.28598 12.0174 3.28615H3.96754L3.62979 1.34406C3.5951 1.13871 3.41583 0.989316 3.20759 0.992229H1.58919C1.35602 0.992229 1.16699 1.18125 1.16699 1.41442C1.16699 1.64759 1.35602 1.83662 1.58919 1.83662H2.85577L4.06605 8.98576C4.10074 9.19111 4.28001 9.3405 4.48825 9.33759H12.0314C12.2646 9.33759 12.4536 9.14856 12.4536 8.91539C12.4536 8.68222 12.2646 8.4932 12.0314 8.4932Z" fill="#9D9D9D"/>
                    </svg>
                    <span>{{ seller.completed_sales_count }}</span>
                </p>

            </div>
            <div v-else class="seller-info__right-description" :class="[elClass, isOnlineGame ? 'online-game' : 'game']">
                <div class="description-online" v-if="isOnlineGame">
                    <span v-if="offer?.additional_data?.game_server">{{ offer.additional_data.game_server }}</span>
                    <span class="last-child" v-if="offer?.additional_data?.game_fraction">{{ offer.additional_data.game_fraction }}</span>
                    <div class="description-online__tooltip">
                        <OfferTooltipInfo :mobile="mobile" :offer="offer" :tablet="tablet" :isOnlineGame="isOnlineGame"/>
                    </div>
                </div>
                <RegionOffer :offer="offer" :typeIcon="1" type="folded" v-else-if="!mobile"/>
            </div>
            <div class=""></div>
        </div>
    </div>
    <div class="seller-info placeholder-wrap" v-else :class="elClass + '-header'">
        <div class="placeholder-wrap__img placeholder"></div>
        <div class="placeholder-wrap__block"><span class="placeholder"></span><span class="placeholder"></span></div>
    </div>
</template>

<script>
import TrustedIconAlt from '/webpack-assets/vue/components/trustedIconAlt.vue';
import OfferTooltipInfo from './OfferTooltipInfo.vue';
import RegionOffer from './RegionOffer.vue';

export default {
  components: {
    TrustedIconAlt,
    OfferTooltipInfo,
    RegionOffer,
  },
  props: {
    offer: {
      type: Object,
      required: true
    },
    seller: {
      type: Object,
      default: null
    },
    isOnlineGame: {
        type: Boolean,
        default: false
    },
    elClass: {
      type: String,
      default: 'seller-top-info'
    },
    simplified: {
        type: Boolean,
        default: false, 
    },
    tablet: {
        type: Boolean,
        default: false,
    },
    mobile: {
        type: Boolean,
        default: false,
    },
  },
  data() {
    return {

    };
  },
  mounted() {

  },
  methods: {
    mobileShowTooltip() {
        if (this.mobile) {
            this.$emit('open:modal');
        }
    },
    getStarCount(count) {
        if (!count) return 0;
        const stars = (count / 100) * 5;
        return Number(stars.toFixed(1));
    }
  },

};
</script>
  
<style lang="scss" scoped>
    .seller-info{
        display: flex;
        align-items: center;
        gap: 15px;
        position: relative;
        @media only screen and (max-width: 767px) {
            width: 100%;
        }
        &.placeholder-wrap{
            @media only screen and (min-width: 1920px) {
                padding-bottom: 5px;
            }
            .placeholder-wrap__img{
                width: 44px;
                height: 44px;
                border-radius: 50%;
                min-width: 44px;
            }
            .placeholder-wrap__block{
                span{
                    display: block;
                    width: 132px;
                    height: 16px;
                    border-radius: 11px;
                    @media only screen and (max-width: 991px) {
                        width: 100px;
                        height: 16px;
                    }
                    &:last-child{
                        margin-top: 5px;
                        height: 12px;
                        width: 150px;
                        @media only screen and (max-width: 991px) {
                            width: 80px;
                            height: 12px;
                        }
                    }
                }
            }
        }
        .img-container{
            max-height: 44px;
            position: relative;

            img{
                border-radius: 50px;
                max-height: 44px;
                max-width: 44px;
                min-height: 44px;
                min-width: 44px;
                object-fit: cover;
            }
            &.game{
                @media only screen and (max-width: 767px) {
                    max-height: 30px;
                    img{
                        max-height: 30px;
                        max-width: 30px;
                        min-height: 30px;
                        min-width: 30px;
                    }
                }
            }
            .online-status{
                .ico-user-status{
                    bottom: 0 !important;
                    height: 10px !important;
                    width: 10px !important;
                    position: absolute;
                    right: 0;
                    border-radius: 50%;
                    background-color: #FF9900;
                    &.online{
                        background-color: #00B241;
                    }
                }
            }
        }
        &__right{
            display: flex;
            flex-direction: column;
            min-width: 0;
            @media only screen and (max-width: 767px) {
                width: 100%;
            }
            &-name{
                display: flex;
                align-items: center;
                .seller-name{
                    font-family: "Avenir-Next-DemiBold", sans-serif;
                    font-weight: 400;
                    font-size: 18px;
                    leading-trim: NONE;
                    line-height: 140%;
                    letter-spacing: 0px;
                    vertical-align: middle;
                    color: #1d1d1d;
                    min-width: 0;
                    overflow: hidden;
                    white-space: nowrap;
                    &.offer-list{
                        -webkit-mask-image: linear-gradient(90deg, #fff 120px, transparent);
                    }
                    &.head{
                        font-size: 18px;
                        @media only screen and (max-width: 1919px) {
                            font-size: 16px;
                        }
                    }
                }
            }
            &-description{
                display: flex;
                margin-top: 5px;
                align-items: center;
                gap: 10px;
                @media only screen and (max-width: 991px) {
                    overflow: hidden;
                    -webkit-mask-image: linear-gradient(90deg, #fff 92%, transparent);
                    .region-block__text{
                        white-space: nowrap;
                    }
                }
                .description-online{
                    display: flex;
                    align-items: center;
                    &__tooltip{
                        border-left: 1px solid #E5E5E5;
                        margin-left: 6px;
                        padding-left: 6px;
                    }
                    span{
                        font-family: "Avenir-Next";
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 20px;
                        letter-spacing: 0px;
                        color: #9D9D9D;
                        white-space: nowrap;
                        max-width: 130px;
                        overflow: hidden;
                        -webkit-mask-image: linear-gradient(90deg, #fff 125px, transparent);
                        &.last-child{
                            border-left: 1px solid #E5E5E5;
                            margin-left: 6px;
                            padding-left: 6px;
                        }
                    }
                }
                &.game{
                    @media only screen and (max-width: 767px) {
                        display: none;
                    }
                }
            }
            &-rank{
                display: flex;
                align-items: center;
                gap: 5px;
                span{
                    font-family: "Avenir-Next";
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 120%;
                    letter-spacing: 0px;
                    color: #9d9d9d;
                    &.achi-name{
                        font-weight: 600;
                        font-style: Demi Bold;
                        &.head{
                            font-size: 14px;
                            @media only screen and (max-width: 1919px) {
                                font-size: 12px;
                            }
                        }
                    }
                }
                .rank-title{
                    @media only screen and (max-width: 1199px) {
                        display: none;
                    }
                }
            }
            &-sale,
            &-rate{
                padding-left: 10px;
                border-left: 1px solid #E5E5E5;
                display: flex;
                align-items: center;
                gap: 5px;
                span{
                    font-family: "Avenir-Next";
                    font-weight: 400;
                    line-height: 99%;
                    height: 9px;
                    letter-spacing: 0px;
                    color: #00B241;
                    font-size: 14px;
                    @media only screen and (max-width: 1919px) {
                        font-size: 12px;
                    }
                }
                &.star{
                    span{
                        font-weight: 600;
                        color: #9d9d9d;
                    }
                }
            }
            &-sale{
                span{
                    font-weight: 400;
                    color: #9d9d9d;
                }
            }
        }
    }
</style>